import { Route } from '@angular/router';
import { AuthGuard } from 'app/core/auth/guards/auth.guard';
import { LayoutComponent } from 'app/layout/layout.component';
import { TabbedPageLayoutComponent } from 'app/layout/page-layouts/tabbed/tabbed-page-layout.component';

export const reportRoutes: Route[] = [
    {
        path: 'reports',
        canActivate: [AuthGuard],
        component: LayoutComponent,
        children: [
            {
                path: 'sport-book',
                component: TabbedPageLayoutComponent,
                children: [
                    {
                        data: {
                            breadcrumbs: [{ label: 'reports.sport-book.sports.title' }],
                            actions: [
                                {
                                    label: '',
                                    icon: 'heroicons_outline:cog-6-tooth',
                                    execute: (componentInstance) => {
                                        componentInstance.openTableColumnSettings();
                                    },
                                },
                                {
                                    label: 'actions.export',
                                    icon: 'heroicons_outline:document-arrow-down',
                                    execute: (componentInstance) => {
                                        componentInstance.exportTableData();
                                    },
                                },
                            ]
                        },
                        path: 'sports',
                        loadComponent: () =>
                            import(
                                './pages/sports-book/sports/sport-book-sports.component'
                            ).then((c) => c.SportsReportComponent),
                    },
                    {
                        data: {
                            breadcrumbs: [{label: 'reports.sport-book.competitions.title'}],
                            actions: [
                                {
                                    label: '',
                                    icon: 'heroicons_outline:cog-6-tooth',
                                    execute: (componentInstance) => {
                                        componentInstance.openTableColumnSettings();
                                    },
                                },
                                {
                                    label: 'actions.export',
                                    icon: 'heroicons_outline:document-arrow-down',
                                    execute: (componentInstance) => {
                                        componentInstance.exportTableData();
                                    },
                                },
                            ]
                        },
                        path: 'competitions',
                        loadComponent: () =>
                            import(
                                './pages/sports-book/competitions/sport-book-competitions.component'
                            ).then((c) => c.CompetitionsComponent),
                    },
                    {
                        data: {
                            breadcrumbs: [
                                {label: 'reports.sport-book.market-types.title'}],
                                actions: [
                                    {
                                        label: '',
                                        icon: 'heroicons_outline:cog-6-tooth',
                                        execute: (componentInstance) => {
                                            componentInstance.openTableColumnSettings();
                                        },
                                    },
                                    {
                                        label: 'actions.export',
                                        icon: 'heroicons_outline:document-arrow-down',
                                        execute: (componentInstance) => {
                                            componentInstance.exportTableData();
                                        },
                                    },
                                ]
                        },
                        path: 'market-types',
                        loadComponent: () =>
                            import(
                                './pages/sports-book/market-types/sport-book-market-types.component'
                            ).then((c) => c.MarketTypesComponent),
                    },
                    {
                        data: {
                            breadcrumbs: [{ label: 'reports.sport-book.bets.title' }],
                            actions: [
                                {
                                    label: '',
                                    icon: 'heroicons_outline:cog-6-tooth',
                                    execute: (componentInstance) => {
                                        componentInstance.openTableColumnSettings();
                                    },
                                },
                                {
                                    label: 'actions.export',
                                    icon: 'heroicons_outline:document-arrow-down',
                                    execute: (componentInstance) => {
                                        componentInstance.exportTableData();
                                    },
                                },
                            ]
                        },
                        path: 'bets',
                        loadComponent: () =>
                            import(
                                './pages/sports-book/bets/sport-book-bets.component'
                            ).then((c) => c.BetsComponent),
                    },
                ],
            },
            {
                path: 'casino/game',
                canActivate: [AuthGuard],
                data: {
                    breadcrumbs: [{ label: 'navigation.reports.casino.game' }],
                    actions: [
                        {
                            label: '',
                            icon: 'heroicons_outline:cog-6-tooth',
                            execute: (componentInstance) => {
                                componentInstance.openTableColumnSettings();
                            },
                        },
                        {
                            label: 'actions.export',
                            icon: 'heroicons_outline:document-arrow-down',
                            execute: (componentInstance) => {
                                componentInstance.exportTableData();
                            },
                        },
                    ]
                },
                component: TabbedPageLayoutComponent,
                children: [
                    {
                        path: '',
                        loadComponent: () =>
                            import(
                                './pages/casino/game/report-by-game.component'
                            ).then((c) => c.ReportByGameComponent),
                    },
                ],
            },
            {
                path: 'casino/player',
                canActivate: [AuthGuard],
                data: {
                    breadcrumbs: [{ label: 'navigation.reports.casino.player' }],
                    actions: [
                        {
                            label: '',
                            icon: 'heroicons_outline:cog-6-tooth',
                            execute: (componentInstance) => {
                                componentInstance.openTableColumnSettings();
                            },
                        },
                        {
                            label: 'actions.export',
                            icon: 'heroicons_outline:document-arrow-down',
                            execute: (componentInstance) => {
                                componentInstance.exportTableData();
                            },
                        },
                    ]
                },
                component: TabbedPageLayoutComponent,
                children: [
                    {
                        path: '',
                        loadComponent: () =>
                            import(
                                './pages/casino/player/report-by-player.component'
                            ).then((c) => c.ReportByPlayerComponent),
                    },
                ],
            },
            {
                path: 'casino/provider',
                canActivate: [AuthGuard],
                data: {
                    breadcrumbs: [{ label: 'navigation.reports.casino.provider' }],
                    actions: [
                        {
                            label: '',
                            icon: 'heroicons_outline:cog-6-tooth',
                            execute: (componentInstance) => {
                                componentInstance.openTableColumnSettings();
                            },
                        },
                        {
                            label: 'actions.export',
                            icon: 'heroicons_outline:document-arrow-down',
                            execute: (componentInstance) => {
                                componentInstance.exportTableData();
                            },
                        },
                    ]
                },
                component: TabbedPageLayoutComponent,
                children: [
                    {
                        path: '',
                        loadComponent: () =>
                            import(
                                './pages/casino/provider/report-by-provider.component'
                            ).then((c) => c.ReportByProviderComponent),
                    },
                ],
            },
            {
                path: 'financial',
                component: TabbedPageLayoutComponent,
                children: [
                    {
                        data: {
                            breadcrumbs: [{ label: 'navigation.reports.financial.payments' }],
                            actions: [
                                {
                                    label: '',
                                    icon: 'heroicons_outline:cog-6-tooth',
                                    execute: (componentInstance) => {
                                        componentInstance.openTableColumnSettings();
                                    }
                                }
                            ]
                        },
                        path: 'payments-report',
                        loadComponent: () =>
                            import(
                                './pages/financial/payments-report/payments-report.component'
                            ).then((c) => c.PaymentsReportComponent),
                    },
                    {
                        data: {
                            breadcrumbs: [{ label: 'navigation.reports.financial.monthly-kpi-report' }],
                            actions: [
                                {
                                    label: '',
                                    icon: 'heroicons_outline:cog-6-tooth',
                                    execute: (componentInstance) => {
                                        componentInstance.openTableColumnSettings();
                                    }
                                }
                            ]
                        },
                        path: 'monthly-kpi-report',
                        loadComponent: () =>
                            import(
                                './pages/financial/monthly-kpi-report/monthly-kpi-report.component'
                            ).then((c) => c.MonthlyKpiReportComponent),
                    },
                ]
            }
        ],
    },
];